  <template>
    <div class="grid grid-cols-6 gap-6">
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="tipo_cap" class="block text-sm font-medium text-gray-700">Tipo CAP <span
              :class="view===''?'hidden':'font-bold text-red-700'">(*)</span></label>
          <select id="tipo_cap" v-model="tipoCap" :disabled="view===''" 
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                 >
            <option value="" selected>Seleccione tipo de CAP...</option>
            <option v-for="(tipoCap, index) of selectTipoCap[0]" :key="'B'+index" :value="tipoCap.id">{{
                tipoCap.nombre
              }}
            </option>
          </select>
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="numero" class="block text-sm font-medium text-gray-700">Número CAP <span
              :class="view===''?'hidden':'font-bold text-red-700'">(*)</span></label>
          <input type="text" id="numero"  v-model="numeroCAP"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="fecha_expedicion" class="block text-sm font-medium text-gray-700">Fecha Expedición CAP <span
              :class="view===''?'hidden':'font-bold text-red-700'">(*)</span></label>
          <input type="date" :disabled="view===''" id="fecha_expedicion" v-model="fechaExpedicion"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>
        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="valor_cap" class="block text-sm font-medium text-gray-700">Valor CAP <span
              :class="view===''?'hidden':'font-bold text-red-700'">(*)</span></label>
          <input type="text" :disabled="view===''" id="valor_cap" v-model="valorCAP"
                @input="formatValorCAP"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>

        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="valor_actual" class="block text-sm font-medium text-gray-700">Valor Actual Pasivo</label>
          <input type="text" id="valor_actual" :value="formattedValorActual" readonly
              class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm readonly-input">
        </div>

        <div class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="tipo_acto_administrativo" class="block text-sm font-medium text-gray-700">Acto administrativo (Ordenanza / Decreto)</label>
          <select id="tipo_acto_administrativo" v-model="tipoActoAdministrativo"
                  class="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500">
            <option value="">Seleccione un tipo de acto...</option>
            <option value="ordenanza">Ordenanza</option>
            <option value="decreto">Decreto</option>
          </select>
        </div>

        <div v-if="tipoActoAdministrativo" class="col-span-6 sm:col-span-3 lg:col-span-2">
          <label for="fecha_expedicion_acto" class="block text-sm font-medium text-gray-700">Fecha de expedición del acto <span class="font-bold text-red-700">(*)</span></label>
          <input type="date" id="fecha_expedicion_acto" v-model="fechaExpedicionActo"
                class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm">
        </div>

        <div class="col-span-6">
          <label for="soportePDF" class="block text-sm font-medium text-gray-700">Soporte CAP<span
              :class="view===''?'hidden':'font-bold text-red-700'">(*)</span></label>
          <input
            type="file"
            name ="soportePDF"
            id="soportePDF"
            accept=".pdf"
            @change="handlePDFUpload();
            documentoSoporte=document.getElementById('soportePDF').files.item(0);"
            class="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm"
          />
          <p class="mt-1 text-xs text-gray-500">Tamaño máximo permitido del archivo adjunto: 40MB (formato PDF).</p>
          <p v-if="selectedData.soportePDF">Archivo adjunto: {{ selectedData.soportePDF }}</p>
        </div>

        <div class="col-span-6 flex justify-center">
          <button @click="handleSave" class="px-4 py-2 text-white bg-blue-500 rounded-md hover:bg-blue-600 focus:outline-none">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="inline-block w-6 h-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7"></path>
            </svg>
            <span class="ml-3">Guardar</span>
          </button>

          <button @click="handleBack" class="px-4 py-2 text-white bg-green-500 ml-3 rounded-md hover:bg-green-600 focus:outline-none">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="inline-block w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M11 19l-7-7 7-7"></path>
            </svg>
            <span class="ml-3">Volver</span>
          </button>
        </div>

        <slot></slot>

      </div>
  </template>
  
<script>
import {separateNumberByCommaInput, swal, useAPIRest} from "@/common/constants";
import {saveUpdateData } from "@/layouts/main";
import { v4 as uuidv4 } from 'uuid';
  export default {
    name: 'CAPComponent',
    props: ['view', 'paginate', 'selectedData','data','loadData', 'entity',
    'collectionTipoCAP','customUpdateLoadData','customUpdateValueData', 
    'customCreateActions'],
    emits: ["updateValues", "customSaveData","cargueSoporte"],
    data() {
      return {
        pasivoExigible:'',
        tipoCap: '',
        numeroCAP: '',
        fechaExpedicion: '',
        tipoActoAdministrativo: '',
        fechaExpedicionActo: '',
        valorCAP: '',
        valorActual: '',
        soportePDF:'',
        document: document
      };
    },
    computed:{
      formattedValorActual(){
        return separateNumberByCommaInput(this.loadData.valor_actual)
      },
    },
    methods: {
      formatValorCAP(){
        this.valorCAP = separateNumberByCommaInput(this.valorCAP);
      },
      async handlePDFUpload() {
         if (this.numeroCAP !== undefined) {
            const nuevoNombre = `${this.numeroCAP}`;
            console.log(nuevoNombre);
          }
      },
      handleBack() {
          this.$emit('updateValues', { 'view': 'listar' });
          //location.reload();
      },

      async handleSave() {

        this.errores = [];
        const fechaExpedicionDate = new Date(this.fechaExpedicion);
        const fechaActual = new Date();

        if (parseFloat(this.valorCAP) <= 0) {
            this.errores.push('El valor del CAP no puede ser negativo o menor que cero.');
        }
        
        if (parseFloat(this.valorCAP) > parseFloat(this.loadData.valor_actual)) {
          this.errores.push('El valor ingresado debe ser inferior al Valor Actual Pasivo.');
        }

        if (fechaExpedicionDate > fechaActual) {
          this.errores.push('La fecha de expedición no puede ser mayor que la fecha actual.');
        }

         // Verificar si el archivo adjunto está presente
        if (!document.getElementById('soportePDF').files.length) {
          this.errores.push('Por favor, adjunte un documento antes de guardar.');
        }

        if (this.tipoActoAdministrativo && !this.fechaExpedicionActo) {
          this.errores.push('Debe indicarse la fecha de expedición del acto administrativo.');
        }

        if (this.errores.length > 0) {
          const errorMessage = this.errores.join('<br>');
          await swal.fire({
            title: 'Error',
            html: errorMessage,
            icon: 'error',
          });
          return;
        }

        console.log('Clic en el botón de guardar');
        const informacion_cap = {
          numero: this.numeroCAP,
          id_tipo_cap: this.tipoCap,
          id_pasivo_exigible: this.selectedData.id,
          fecha_expedicion: this.fechaExpedicion,
          valor_cap: this.valorCAP.replaceAll(',',''),
          tipo_acto_administrativo: this.tipoActoAdministrativo || null,
          fecha_expedicion_acto: this.tipoActoAdministrativo ? this.fechaExpedicionActo : null,
        };
        console.log(informacion_cap);
        await this.customSaveData(informacion_cap);
      },
      async customSaveData(informacion_cap) {
        try {
          console.log(informacion_cap.numero)
          const listApi = {
            create: process.env.VUE_APP_NEST_CAP_CREATE
          };
         
          const resJSON = await saveUpdateData({
            listApi,
            authToken: this.authToken,
            loadData: informacion_cap,
            action: 'crear',
            entity: this.entity,
          }, undefined, false, false);

          console.log('resJson', resJSON);
          const id_cap_creado = resJSON.id;
          if(resJSON.statusCode === 201){
            await this.guardarSoporte(id_cap_creado);
          }
        }catch (error) {
          console.error('Error al guardar:', error);
        }
      },

      async guardarSoporte(id_cap) {
        let documentoSoporte=document.getElementById('soportePDF').files.item(0);
        const uniqueFilename = `${uuidv4()}-${documentoSoporte.name}`;
        const url = `src/assets/documentos_soporte_pasivos_exigibles/${uniqueFilename}`;
        const soporte_cap = {
          id_cap: id_cap,
          url_archivo: url,
        };
        console.log(soporte_cap);
        try {
          const listApi = {
            create: process.env.VUE_APP_NEST_SOPORTE_CAP_CREATE
          };
         
          const resJSON = await saveUpdateData({
            listApi,
            authTnoken: this.authToken,
            loadData: soporte_cap,
            action: 'crear',
            entity: this.entity,
          }, undefined, true, false);

          console.log(resJSON);
          await this.cargueSoporte(uniqueFilename);
        }catch (error) {
          console.error('Error al guardar:', error);
        }
      },

      async cargueSoporte(uniqueFilename){
        let documentoSoporte=document.getElementById('soportePDF').files.item(0);
        // const uniqueFilename = `${uuidv4()}-${documentoSoporte.name}`;
        const newLoadData = new FormData();
        newLoadData.append('form', JSON.stringify({ uniqueFilename }));
        if (documentoSoporte) {
          const pesoMaximo = 40 * 1024 * 1024;
          if (documentoSoporte.size > pesoMaximo) {
            documentoSoporte = undefined;
            await swal.fire('¡El archivo excede el tamaño de 40MB maximo permitido!', '', 'error');
          } else
            newLoadData.append('file', documentoSoporte, `${uniqueFilename}`);
        }
        try {
          let resJSONSoporte = await useAPIRest(process.env.VUE_APP_NEST_SOPORTE_CAP_CARGARARCHIVO, 'POST', this.authToken, newLoadData, undefined, 'auto');
          console.log(resJSONSoporte);
          this.$emit('updateValues', { 'view': 'listar' });
          location.reload();
  
        } catch (error) {
          console.error('Error al cargar soporte:', error);
        }
      },
    },
    async setup(props){
      const selectTipoCap = await Promise.all(props.customCreateActions?.map(async action => await action()))
      console.log('selectTipoCap:', selectTipoCap)
      return {
        selectTipoCap
      }
    },

  };
  </script>

  
<style scoped>
.readonly-input {
  background-color: #f2f2f2;
}
</style>

